import { backgroundStyles, dividerStyles, fontStyles } from 'styles/theme';

import { Drawer as AntDrawer } from 'antd';
import { X } from 'react-feather';
import { hexToRGBA } from 'utils/common';
import styled from '@emotion/styled';

export const ButtonContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  padding: '12px 20px',
});

export const Drawer = styled(AntDrawer)({
  '& .ant-drawer-body': {
    padding: 0,
  },
  '& .ant-drawer-header': {
    borderBottom: `1px solid ${dividerStyles.colors.primary}`,
  },
});

export const DrawerTitleContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 20,
});

export const CloseDrawerIcon = styled(X)({
  color: '#637381',
  width: '20px',
  maxHeight: '20px',
});

export const SideDrawerList = styled.li({
  listStyleType: 'none',
  paddingTop: 6,
});

export const SideDrawerListItem = styled.ul({
  padding: '12px 20px',
  margin: 0,
  '&:active': {
    backgroundColor: hexToRGBA(backgroundStyles.colors.primary, 0.15),
  },
  '& a': {
    color: fontStyles.colors.primary,
  },
});
